module.exports = __webpack_public_path__ + "img/M_Read_more_risks.a35e7331.svg";